<template>
  <div class="payment-method" v-if="order_details">
    <h5>{{_T('Payment Method')}}</h5>
    <div class="payment-card" v-if="order_details.order_payments.length">
      <div class="card-detail">
        <h6>XXXX-XXXX-XXXX-98</h6>
        <h6><span>09/19</span></h6>
      </div>
      <div>
        <img
          src="/images/checkout/master-card-square.png"
          alt=""
          class="img-fluid"
        />
      </div>
    </div>
    <div>
      <h6><span>{{ _T('Under process') }}</span></h6>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
export default {
  computed:{
    ...mapGetters(['_T']),
    ...mapState({
      order_details: state => state.tracking_store.order_details
    })
  }
}
</script>

<style lang="scss" scoped>
.payment-method {
  padding: calc(#{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
    calc(#{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
    calc(#{$px30} + (53 - 30) * ((100vw - #{$px320}) / (1920 - 320)));
     h5 {
      font-weight: 600;
      margin-bottom: calc(#{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
  }
  .payment-card {
    justify-content: space-between;
    display: flex;
    padding: calc(#{$px10} + (16 - 10) * ((100vw - #{$px320}) / (1920 - 320)));
    background-color: $white;
    border-radius: $px4;
    border: $px1 solid $dark-border;
    align-items: center;
    .card-detail {
      h6 {
        margin-bottom: 0;
        font-weight: 600;
        font-size: 13.5px;
        line-height: $px21;
        span {
          color: $light-font;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .payment-method {
    .steps-status {
        .media {
            .icon-status {
                width: $px40;
                height: $px40;
                img {
                    width: 55%;
                }
            }
        }
        &::after {
            display: none;
        }
    }
}
}
</style>
